import React from "react";
import { Link } from "react-router-dom";
import icon from "../assets/icons/onegat.webp";

const QuienesSomos = () => {
  return (
    <div className="container d-flex flex-column align-items-center justify-content-center py-5 min-vh-100">
      {/* Título */}
      <div className="w-75 bg-dark text-white py-4 text-center shadow-lg rounded">
        <h1 className="display-5 fw-bold">Sobre Onegat</h1>
      </div>

      {/* Descripción principal */}
      <div className="w-75 mt-4">
        <p
          className="text-muted text-center"
          style={{ lineHeight: 1.8, fontSize: "1.05rem" }}
        >
          <strong>ONEGAT</strong> es un software desarrollado de forma privada y con
          medios propios por su autor, titular del programa y de la marca registrada.
          La aplicación está inscrita en el Registro de la Propiedad Intelectual y su
          marca también se encuentra protegida.
        </p>

        <p
          className="text-muted text-center mt-3"
          style={{ lineHeight: 1.8, fontSize: "1.05rem" }}
        >
          La actividad vinculada a <strong>ONEGAT</strong> es exclusivamente
          tecnológica y mercantil, basada en la explotación de derechos de propiedad
          intelectual mediante licencias de uso en modalidad SaaS (Software as a Service).
          No presta asesoramiento municipal, mediación o servicios administrativos
          de ningún tipo.
        </p>

        <p
          className="text-muted text-center mt-3"
          style={{ lineHeight: 1.8, fontSize: "1.05rem" }}
        >
          ONEGAT nace con el objetivo de ofrecer una herramienta digital para la
          organización interna de datos relacionados con colonias felinas gestionadas
          bajo el método CES, facilitando el registro estructurado de información,
          el seguimiento de actuaciones y la generación de informes para uso interno
          de las entidades que lo utilizan.
        </p>
      </div>

      {/* Imagen */}
      <img
        src={icon}
        alt="Logo Onegat"
        className="mt-4 shadow-lg"
        style={{ width: "260px", height: "auto", borderRadius: "15px" }}
      />

      {/* Disclaimer legal complementario */}
      <div
        className="alert alert-secondary mt-4 w-75 text-center shadow-sm"
        role="alert"
        style={{ lineHeight: 1.6, fontSize: "0.95rem" }}
      >
        <strong>Transparencia y compatibilidad:</strong> ONEGAT se desarrolla al amparo
        del régimen de incompatibilidades del personal al servicio de las Administraciones
        Públicas, como actividad tecnológica y mercantil basada en la creación y explotación
        de software propio.
      </div>

      {/* Botón de regreso */}
      <Link to="/preview" className="mt-4 mb-5">
        <button className="btn btn-outline-primary btn-lg shadow-lg px-5 py-3 rounded-pill">
          Volver a Inicio
        </button>
      </Link>
    </div>
  );
};

export default QuienesSomos;
